import { render, staticRenderFns } from "./incl-siteNewsletter-list.vue?vue&type=template&id=5d5e7412"
import script from "./incl-siteNewsletter-list.vue?vue&type=script&lang=js"
export * from "./incl-siteNewsletter-list.vue?vue&type=script&lang=js"
import style0 from "./incl-siteNewsletter-list.vue?vue&type=style&index=0&id=5d5e7412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports